import GenericErrorModal from './GenericErrorModal';

export default GenericErrorModal;
